module.exports = __webpack_public_path__ + "static/media/4.02c28eb4.png";